import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Button, Col, Row } from "reactstrap";
import { seti18nextLanguage, translationHookOptions } from "../app/localization/localization";

const ZwibblerTestPage = () => {
  //const rootStore = useContext(RootStoreContext);
  const [t] = useTranslation(["translation", "features"], translationHookOptions);

  return (
    <div>
      <h1>{t("test_page_tiltle_bar", { ns: "features" })}</h1>
      <div style={{ width: "100%", height: "80vh" }}>
        <Row>
          <Col>
            <Button color="green" onClick={() => seti18nextLanguage("it-IT") }>
              Italiano
            </Button>
          </Col>
          <Col>
            <Button color="blue" onClick={() => seti18nextLanguage("en-US")}>
              English
            </Button>
          </Col>
          <Col>
            <Button color="red" onClick={() => seti18nextLanguage("es-ES")}>
              Español
            </Button>
          </Col>
        </Row>
        <Row className="mt-2">
          <ol>
            <li>{t("loading")}</li>
            <li>{t("confirm")}</li>
            <li>{t("save")}</li>
            <li>{t("meeting_page_title_bar", { ns: "features" })}</li>
            <li>{t("board_page_title_bar", { ns: "features" })}</li>
            <li>{t("mydocs_page_title_bar", { ns: "features" })}</li>
          </ol>
        </Row>
      </div>
    </div>
  );
};

export default observer(ZwibblerTestPage);
